export default __webpack_public_path__ + "static/media/Check.20fb7110.gif";